"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAxiosError = exports.axiosConfig = void 0;
const axiosConfig = token => {
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};
exports.axiosConfig = axiosConfig;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAxiosError = e => {
  let error;
  if (!e) {
    error = new Error('No error defined');
  } else if (e.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx    
    error = new Error(`Axios ${e.response.status} error: ${JSON.stringify(e.response.data)}`);
  } else {
    // Something happened in setting up the request that triggered an Error
    error = new Error(e.message ? e.message : 'An unknown error has occurred.');
  }
  return error;
};
exports.getAxiosError = getAxiosError;